import { z } from "zod";

const SelectOptionsSchema = z.object({
    id: z.number(),
    label: z.string(),
});

export type ISelectOption = z.infer<typeof SelectOptionsSchema>;

const SelectOptionsNullableSchema = SelectOptionsSchema.extend({
    id: z.number().nullable(),
});

export type SelectOptionNullable = z.infer<typeof SelectOptionsNullableSchema>;

export const defaultISelectOption: SelectOptionNullable = {
    id: null,
    label: "",
};
